__turbopack_context__.v({
  "table-cell-content": "FeatureCell-module__W36xnq__table-cell-content",
});
